export default {"src":"/_next/static/media/truemed_logo_white.60b591e4.svg","height":25,"width":120,"blurWidth":0,"blurHeight":0};